import React, { Component } from "react";
import Radium from "radium";
import { ErrorBoundary } from "@sentry/react";
import CastleRouter from "./routes/CastleRouter";
import CastleError from "./ui/CastleError";
import CastleLoader from "./ui/CastleLoader";
import CastleMessage from "./ui/CastleMessage";
import { muiTheme } from "./ui/theme/materialUiTheme";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ToastContextProvider } from "./context/ToastContext";
import { LoanPdfProvider } from "./context/LoanPdfContext";
import { MixpanelProvider } from "./context/MixpanelContext";
import { CountyLimitsProvider } from "./context/CountyLimitsContext";

class Castle extends Component {
  render() {
    return (
      <div>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ThemeProvider theme={muiTheme}>
            <ToastContextProvider>
              <MixpanelProvider
                mixpanelToken={process.env.REACT_APP_MIXPANEL_TOKEN}
              >
                <LoanPdfProvider>
                  <CountyLimitsProvider>
                    <ErrorBoundary
                      fallback={() => <p>An error has occurred.</p>}
                    >
                      <CastleRouter />
                      <CastleLoader />
                      <CastleError />
                      <CastleMessage />
                    </ErrorBoundary>
                  </CountyLimitsProvider>
                </LoanPdfProvider>
              </MixpanelProvider>
            </ToastContextProvider>
          </ThemeProvider>
        </LocalizationProvider>
        {/*<div style={{ backgroundColor: 'black' }}>*/}
        {/*  <img src="/img/svg_icons/add_plus.svg" />*/}
        {/*  <img src="/img/svg_icons/added_check_list_view.svg" />*/}
        {/*  <img src="/img/svg_icons/arm_bold.svg" />*/}
        {/*  <img src="/img/svg_icons/arm_thin.svg" />*/}
        {/*  <img src="/img/svg_icons/available_loan_options.svg" />*/}
        {/*  <img src="/img/svg_icons/calculator.svg" />*/}
        {/*  <img src="/img/svg_icons/Calendar.svg" />*/}
        {/*  <img src="/img/svg_icons/chat_review.svg" />*/}
        {/*  <img src="/img/svg_icons/clear_logo.svg" />*/}
        {/*  <img src="/img/svg_icons/Condo.svg" />*/}
        {/*  <img src="/img/svg_icons/credit_score.svg" />*/}
        {/*  <img src="/img/svg_icons/downpayment.svg" />*/}
        {/*  <img src="/img/svg_icons/Duplex.svg" />*/}
        {/*  <img src="/img/svg_icons/edit.svg" />*/}
        {/*  <img src="/img/svg_icons/fast_track.svg" />*/}
        {/*  <img src="/img/svg_icons/fixed_bold.svg" />*/}
        {/*  <img src="/img/svg_icons/fixed_thin.svg" />*/}
        {/*  <img src="/img/svg_icons/Info.svg" />*/}
        {/*  <img src="/img/svg_icons/Info_dark.svg" />*/}
        {/*  <img src="/img/svg_icons/Insight_Path.svg" />*/}
        {/*  <img src="/img/svg_icons/irq_view_as_grid.svg" />*/}
        {/*  <img src="/img/svg_icons/loan_comparison.svg" />*/}
        {/*  <img src="/img/svg_icons/loan_type_background_not_selected.svg" />*/}
        {/*  <img src="/img/svg_icons/loan_type_background_selected.svg" />*/}
        {/*  <img src="/img/svg_icons/location.svg" />*/}
        {/*  MAN IN FRONT OF HOUSE:*/}
        {/*  <img src="/img/svg_icons/man_in_front_of_house.svg" />*/}
        {/*  <img src="/img/svg_icons/or_downpayment.svg" />*/}
        {/*  <img src="/img/svg_icons/profile.svg" />*/}
        {/*  <img src="/img/svg_icons/property_value_small.svg" />*/}
        {/*  <img src="/img/svg_icons/property_type.svg" />*/}
        {/*  <img src="/img/svg_icons/Quadraplex.svg" />*/}
        {/*  <img src="/img/svg_icons/rate_lock_period.svg" />*/}
        {/*  <img src="/img/svg_icons/refresh.svg" />*/}
        {/*  <img src="/img/svg_icons/self_employed.svg" />*/}
        {/*  <img src="/img/svg_icons/share.svg" />*/}
        {/*  <img src="/img/svg_icons/Single_Family.svg" />*/}
        {/*  <img src="/img/svg_icons/Townhouse.svg" />*/}
        {/*  <img src="/img/svg_icons/Triplex.svg" />*/}
        {/*  <img src="/img/svg_icons/us_citizen.svg" />*/}
        {/*  <img src="/img/svg_icons/va_eligible.svg" />*/}
        {/*  <img src="/img/svg_icons/view_loan_details.svg" />*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default Radium(Castle);
